import React from 'react';
import MenuPainel from '../components/MenuPainel';
import PaperForm from '../components/PaperForm';
import { ChangePassword } from '../components/ChangePassword';
import ActionPassage from '../components/ActionPassage';
import GlobalStyle from '../styles/globalStyle';
import { CssBaseline } from '@material-ui/core';
class Actionpassage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel>
          <PaperForm
            title={''}
            margin={'15px 0'}
            elevation={24}
            componente={<ActionPassage />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

const connectedAssinar = Actionpassage;
export { connectedAssinar as Actionpassage };
